import * as React from "react"
export const Svg_023 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M25.035 43.956h7.93v3.457h-7.93v-3.457Z" />
      <path
        fill="url(#c)"
        d="M51.483 38.456V40.5H58v-6.63h-2.008c-2.486 0-4.51 2.058-4.51 4.587Z"
      />
      <path
        fill="url(#d)"
        d="M55.992 11.303H58v-6.63h-6.517v2.042c0 2.53 2.023 4.588 4.51 4.588Z"
      />
      <path
        fill="url(#e)"
        d="M36.363 40.499h11.721v-2.043c0-4.435 3.548-8.044 7.908-8.044H58V14.76h-2.008c-4.36 0-7.908-3.609-7.908-8.045V4.673h-11.72V40.5Zm4.59-19.642h3.398v3.457h-3.399v-3.457Z"
      />
      <path
        fill="url(#f)"
        d="M9.916 38.456V40.5h11.72V4.673H9.917v2.042c0 4.436-3.548 8.045-7.908 8.045H0v15.652h2.008c4.36 0 7.908 3.609 7.908 8.044Zm3.733-17.599h3.399v3.457h-3.399v-3.457Z"
      />
      <path
        fill="url(#g)"
        d="M6.517 38.456c0-2.529-2.023-4.587-4.51-4.587H0v6.63h6.517v-2.043Z"
      />
      <path fill="url(#h)" d="M0 43.956h21.637v3.457H0v-3.457Z" />
      <path fill="url(#i)" d="M25.035 4.673h7.93V40.5h-7.93V4.673Z" />
      <path fill="url(#j)" d="M0 50.87h21.637v3.457H0V50.87Z" />
      <path fill="url(#k)" d="M36.363 43.956H58v3.457H36.363v-3.457Z" />
      <path fill="url(#l)" d="M36.363 50.87H58v3.457H36.363V50.87Z" />
      <path fill="url(#m)" d="M25.035 50.87h7.93v3.457h-7.93V50.87Z" />
      <path
        fill="url(#n)"
        d="M6.517 6.715V4.673H0v6.63h2.008c2.486 0 4.51-2.058 4.51-4.588Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={26.869}
        x2={27.791}
        y1={44.474}
        y2={47.898}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.99}
        x2={56.163}
        y1={34.864}
        y2={39.912}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={52.99}
        x2={56.163}
        y1={5.668}
        y2={10.716}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={41.367}
        x2={60.39}
        y1={10.047}
        y2={28.641}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={5.003}
        x2={24.026}
        y1={10.047}
        y2={28.641}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={1.507}
        x2={4.68}
        y1={34.864}
        y2={39.912}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={5.003}
        x2={5.363}
        y1={44.474}
        y2={48.111}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={26.869}
        x2={38.951}
        y1={10.047}
        y2={14.375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={5.003}
        x2={5.363}
        y1={51.388}
        y2={55.025}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={41.367}
        x2={41.726}
        y1={44.474}
        y2={48.111}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="l"
        x1={41.367}
        x2={41.726}
        y1={51.388}
        y2={55.025}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="m"
        x1={26.869}
        x2={27.791}
        y1={51.388}
        y2={54.812}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="n"
        x1={1.507}
        x2={4.68}
        y1={5.668}
        y2={10.716}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)